/**
 * @generated SignedSource<<91211e8ac9537435671dd432c06fc246>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionJuryFragment$data = {
  readonly id: string;
  readonly jury: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly displayName: string;
        readonly id: string;
        readonly jobTitle?: string | null | undefined;
        readonly username: string;
        readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
      };
      readonly selectedOn: string;
    }>;
  };
  readonly viewerCanAddJuryMember: boolean;
  readonly viewerCanRemoveJuryMember: boolean;
  readonly " $fragmentType": "CompetitionJuryFragment";
};
export type CompetitionJuryFragment$key = {
  readonly " $data"?: CompetitionJuryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionJuryFragment">;
};

import CompetitionJuryFragmentPaginationQuery_graphql from './CompetitionJuryFragmentPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "jury"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": CompetitionJuryFragmentPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "CompetitionJuryFragment",
  "selections": [
    {
      "alias": "viewerCanAddJuryMember",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "ADD_COMPETITION_JURY"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"ADD_COMPETITION_JURY\")"
    },
    {
      "alias": "viewerCanRemoveJuryMember",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "REMOVE_COMPETITION_JURY"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"REMOVE_COMPETITION_JURY\")"
    },
    {
      "alias": "jury",
      "args": null,
      "concreteType": "CompetitionJuryConnection",
      "kind": "LinkedField",
      "name": "__CompetitionJuryFragment_jury_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompetitionJuryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "selectedOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "username",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jobTitle",
                      "storageKey": null
                    }
                  ],
                  "type": "User",
                  "abstractKey": null
                },
                {
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "thumbnail",
                      "value": true
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "EntityProfilePicFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Competition",
  "abstractKey": null
};
})();

(node as any).hash = "ebd2eef80a2c88077fa0c15bd7d0f71a";

export default node;
